import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({ providedIn: 'root' })
export class PerseusAdminGuard {
  constructor(private configService: ConfigService) {}
  public async canActivate(): Promise<boolean> {
    while (!this.configService.userSettings()) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return !!this.configService.userSettings()?.isPerseusAdmin;
  }
}
